function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';
export const CreditCardSvgIcon = ({
  svgColor = '#6C6D6E',
  wrapperClassName = '',
  style = {}
}) => /*#__PURE__*/React.createElement(SvgIcon, {
  className: wrapperClassName,
  style: _objectSpread({
    height: 'auto',
    width: 'auto'
  }, style),
  width: "21px",
  height: "16px",
  viewBox: "0 0 21 16"
}, /*#__PURE__*/React.createElement("g", {
  id: "Multiple-/-Transfer-/-Pull-",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "multiple-addresses-(8)",
  transform: "translate(-730.000000, -1189.000000)",
  stroke: svgColor,
  strokeWidth: "1.12570356"
}, /*#__PURE__*/React.createElement("g", {
  id: "section",
  transform: "translate(360.000000, 491.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(100.000000, 630.000000)",
  id: "input-fields"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(270.000000, 64.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "section-"
}, /*#__PURE__*/React.createElement("g", {
  id: "credit-card-1",
  transform: "translate(1.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "container",
  x: "-4.09533518e-14",
  y: "-4.09533518e-14",
  width: "19",
  height: "14",
  rx: "0.844277674"
}), /*#__PURE__*/React.createElement("line", {
  x1: "-4.09533518e-14",
  y1: "3.5",
  x2: "19",
  y2: "3.5",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: "4",
  y1: "7.5",
  x2: "11",
  y2: "7.5",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: "4",
  y1: "10.5",
  x2: "8",
  y2: "10.5",
  id: "Path"
})))))))));